import { api } from 'src/common/utils';
import { CampaignDetailType } from 'src/tcr/types';

import {
  CampaignProps,
  PhoneProps,
  RequestApiListResponseType,
  RequestApiPaginationResponseType,
} from './types';

export const fetchMetabaseDashboardToken = (
  dashboardId: string | number
): Promise<{
  dashboard_token: string;
}> =>
  new Promise((resolve, reject) => {
    api
      .get(`/third_party/metabase/dashboard_token?ignore_account=true&dashboard_id=${dashboardId}`)
      .then(({ data }) =>
        resolve(
          data as {
            dashboard_token: string;
          }
        )
      )
      .catch((err) => reject(err));
  });

export const fetchPhones = async (
  filter: {
    account: string;
    campaign: string;
    phone: string;
  },
  currentPage: number
): Promise<RequestApiPaginationResponseType<PhoneProps>> => {
  const url =
    `/campaign_management/phones?page=${currentPage}&` +
    Object.entries(filter)
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      .filter(([key, value]) => value !== undefined)
      .map(([key, value]) => (value ? `${key}=${encodeURIComponent(value)}` : ''))
      .join('&');
  const response: RequestApiPaginationResponseType<PhoneProps> = await api.get(url);
  return response;
};

export const fetchCampaigns = async (): Promise<CampaignProps[]> => {
  const response: RequestApiListResponseType<CampaignProps> = await api.get(
    '/campaign_management/campaigns'
  );
  return response.data;
};

export const addNumberToCampaign = async (numbers: string[], campaign: string): Promise<void> => {
  const result: any = await api.post('/campaign_management/bandwidth/assign_campaign_to_phones', {
    phone_numbers: numbers.map((number) => ({ phone_number: number, target_campaign: campaign })),
  });
  if (result?.data?.TnOptionOrderResponse?.ResponseStatus?.ErrorCode)
    throw new Error(
      result?.data?.TnOptionOrderResponse?.ResponseStatus?.Description ||
        'An error occurred while assigning the phone to the campaign.'
    );
};

export const addNumberToAccount = async (numbers: string[], account: string): Promise<void> => {
  const result: any = await api.post('/campaign_management/bandwidth/assign_account_to_phones', {
    phone_numbers: numbers,
    target_account: account,
  });
  if (result?.data?.TnOptionOrderResponse?.ResponseStatus?.ErrorCode)
    throw new Error(
      result?.data?.TnOptionOrderResponse?.ResponseStatus?.Description ||
        'An error occurred while assigning the phone to the account.'
    );
};

export const scalingToCampaign = async (data: any): Promise<void> => {
  const result: any = await api.post(
    '/campaign_management/tcr_campaigns/create_tcr_campaign',
    data
  );
  if (result.data.error) throw new Error(result.data.message);
  return result.data;
};

export const saveCampaignDetails = async (data: any): Promise<void> => {
  const result: any = await api.post('/campaign_management/campaign_details', data);
  if (result.data.error) throw new Error(result.data.message);
  return result.data;
};

export const updateCampaignDetails = async (data: any): Promise<void> => {
  const result: any = await api.patch(`/campaign_management/campaign_details/${data?.id}`, data);
  if (result.data.error) throw new Error(result.data.message);
  return result.data;
};

export const deleteCampaignDetails = async (id: string): Promise<void> => {
  const result: any = await api.delete(`/campaign_management/campaign_details/${id}`);
  if (result.data.error) throw new Error(result.data.message);
  return result.data;
};

export const getCampaignDetails = async (id: string): Promise<void> => {
  const result: any = await api.get(`/campaign_management/campaign_details/${id}`);
  if (result.data.error) throw new Error(result.data.message);
  return result.data;
};

export const fetchCampaignDetails = async (
  name: string
): Promise<{ results: CampaignDetailType[] }> => {
  const result: any = await api.get(`/campaign_management/campaign_details?search=${name}`);
  if (result.data.error) throw new Error(result.data.message);
  return result.data;
};
